import callAPiBase from './base';

const companyUsersApi = {
  check: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyCheckUsers',
      method: 'POST',
      useToken: true,
      title: 'Company - Check Users',
      data,
    }),
  chargeRequestExtern: ({
    formData,
    transportOperator,
  }: {
    formData: FormData;
    transportOperator: string;
  }) =>
    callAPiBase({
      endpoint: `/companyCreateChargeRequestExtern?transportOperatorId=${transportOperator}`,
      method: 'POST',
      useToken: true,
      title: 'Order - ChargeRequestExtern',
      formData,
    }),
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyListUsers',
      method: 'GET',
      useToken: true,
      title: 'Company - Get List Users',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyAddUsers',
      method: 'POST',
      useToken: true,
      title: 'Company - Create Users',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyUpdateUsers',
      method: 'POST',
      useToken: true,
      title: 'Company - Update Users',
      data,
    }),
  delete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyDeleteUsers',
      method: 'POST',
      useToken: true,
      title: 'Company - Delete Users',
      data,
    }),

  deleteUser: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/appUserDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Company - Delete User',
      params,
    }),
};

export { companyUsersApi };
export default companyUsersApi;
